import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../components/Table';
import { useGetAllAssignmentMarkQuery } from '../features/assignment/assignmentApi';
import { useDeleteVideoMutation } from '../features/video/videoApi';

const AssignmentMarks = () => {
  const tableHead=['Assignment','Date','Student Name','Repo Link','Mark'];

  const {data:assignments,isError,isLoading,isSuccess,error,refetch}=useGetAllAssignmentMarkQuery();
  const[deleteVideo, {}]=useDeleteVideoMutation();

 const tableKeyNames=['title','createdAt','student_name','repo_link','mark'];
 const navigate=useNavigate();

 const handleEdit=(id)=>{
navigate(`/admin/videos/edit/${id}`)
 }

 const handleDelete=(id)=>{
  deleteVideo(id)
 }

  return (
    <>
  

<section className="py-6 bg-primary">
  <div className="mx-auto max-w-full px-5 lg:px-20">
    <div className="px-3 py-20 bg-opacity-10">
      <ul className="assignment-status">
        <li>Total <span>{assignments?.length}</span></li>
        <li>Pending <span>{assignments?.filter(it=>it.status=='pending')?.length}</span></li>
        <li>Mark Sent <span>{assignments?.filter(it=>it.status=='published')?.length}</span></li>
      </ul>
      <div className="overflow-x-auto mt-4">


      <Table refetch={refetch} handleEdit={handleEdit} handleDelete={handleDelete} tableHead={tableHead} data={assignments} tableKeyNames={tableKeyNames} showDelete={true}  showEdit={true} isSuccess={isSuccess} isError={isError} isLoading={isLoading}/>


      </div>
    </div>
  </div>
</section>


    </>
  )
}

export default AssignmentMarks